module.exports = __webpack_public_path__ + "static/media/IMG_5049.9c7d1f77.JPG";